import GeneratorForm from '../../../components/GeneratorForm/GeneratorForm.jsx';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fakeResponse } from '../../../utils/helpers.js';
import { mockArticle } from '../../../utils/mockData.js';
import AccessModal from '../../../components/Modal/AccessModal.jsx';
import useAccessType from '../../../hooks/useAccessType.js';
import DemoModal from '../../../components/Modal/DemoModal.jsx';
import { authFetch } from '../../../utils/apiClient.js';

function ArticleGeneratorScreen() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [keyword, setKeyword] = useState(null);
    const { getAccessType, isDemo } = useAccessType();
    const [modalType, setModalType] = useState(null);

    async function generateArticle(language, tone, contentLength, subject, keywords) {
        try {
            const res = await authFetch("/api/article/generate", {
                method: "POST",
                body: JSON.stringify({
                    language,
                    tone,
                    contentLength,
                    subject,
                    keywords
                })
            });

            return await res.json()
        } catch (error) {
            console.error("Error generating article:", error);
            return null;
        }
    }

    async function generateFakeArticle() {
        return fakeResponse(mockArticle);
    }

    const handleDemo = async () => {
        setIsLoading(true);
        const data = await generateFakeArticle();
        navigate('/article/generated', { state: { article: data, idea: keyword } });
    };

    const handleSubmit = async (formData) => {
        const { language, tone, contentLength, subject, keywords } = formData;
        if (isDemo) {
            setKeyword(subject);
            setShowModal(true);
            return;
        }
        const accessType = getAccessType();
        if (accessType) {
            setModalType(accessType);
            setShowModal(true);
            return;
        }

        setIsLoading(true);
        const data = await generateArticle(language, tone, contentLength, subject, keywords);
        navigate('/article/generated', { state: { article: data, idea: subject } });
    };

    return (
        <>
            <GeneratorForm
                title="article.generateArticle"
                placeholderSubject="article.placeholderSubject"
                placeholderKeywords="article.placeholderKeywords"
                onSubmit={handleSubmit}
                isLoading={isLoading}
            />
            <AccessModal
                show={showModal && !isDemo}
                setShow={setShowModal}
                modalType={modalType}
            />
            <DemoModal
                show={showModal && isDemo}
                setShow={setShowModal}
                onAction={handleDemo}
            />
        </>
    );
}

export default ArticleGeneratorScreen;